import React, { useState } from 'react';
import './FlipCard.css';

const FlipCard = ({ frontImage, frontTitle, frontDescription, backTitle, backDescription, link, linkText = 'Explore' }) => {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  return (
    <div className={`flip-card ${isFlipped ? 'flipped' : ''}`} onClick={handleFlip}>
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <div className="card-content">
            <div className="card-logo">
              <img src={frontImage} alt={frontTitle} />
            </div>
            <h3>{frontTitle}</h3>
            <p>{frontDescription}</p>
          </div>
        </div>
        <div className="flip-card-back">
          <div className="card-content">
            <h3>{backTitle}</h3>
            <p>{backDescription}</p>
            {link && (
              <a href={link} target="_blank" rel="noopener noreferrer" className="btn flip-btn" onClick={(e) => e.stopPropagation()}>
                {linkText}
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlipCard;